export { default } from './EmprestimoGarantiaCarroTemContrato';
